import React, {useEffect, useState} from 'react';
import { useSelector } from "react-redux";
import Construct from "../../Construct";

import { styled } from '@mui/material';

const PREFIX = 'Navigation';

const classes = {
    root: `${PREFIX}-root`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%',
        height: '100%',
		backgroundColor: theme.palette.background.default
    }
}));

export default function Navigation({ selector, details }) {


    // App State
    const filters = useSelector(state => state.data.filters);

    // Component State
    const [navigateDetails, setNavigateDetails] = useState(false);

    useEffect(() => {
        if (filters) {
            const fieldFilter = filters.find(f => {
                return f.field === 'gid'
            });
            setNavigateDetails(fieldFilter ? true : false);
        }
    }, [filters]);

    // console.log('navigateDetails', navigateDetails);

    return (
        <Root className={classes.root}>
            {!navigateDetails &&
                <Construct layout={{configuration: selector}}/>
            }
            {navigateDetails &&
                <Construct layout={{configuration: details}}/>
            }
        </Root>
    );
}
